import $ from 'jquery';
import Slider from 'blocks/slider/slider';
import Animation from 'modules/animation/animation';
import Numbered from 'input.numbered';

export default class {
	constructor(options) {
		const defaults = {
			el: '.b-application#yotaApplication',
			dom: {
				form: '.js-application-form',
				tabs: '.js-application-tabs .js-tab',
				slider: '.js-application-slider',
				control: '.js-application-control',
				links: '.js-application-links',
				numbered: '#applicationNumbered',
				button: '.js-application-send',
				mask: '.js-application-mask',
				fileds: '.js-application-fileds',
				reset: '.js-application-reset',
				captcha: '#applicationCaptcha',
				phone: '.js-application-phone',
				callback: '.js-application-callback'
			},
			classes: {
				state: {
					tabs: {
						ios: 'b-application_tab_ios',
						android: 'b-application_tab_android',
						'windows-phone': 'b-application_tab_windows'
					},
					active: 'b-application_state_active',
					form: {
						captcha: 'b-application_state_captcha',
						send: 'b-application_state_send'
					},
					input: {
						error: 'b-application__input_state_error'
					},
					mask: {
						hidden: 'b-application__mask_state_hidden'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.preventChange = false;
		return this;
	}

	getDom() {
		const self = this;
		self.$form = self.$el.find(self.options.dom.form);
		self.$tabs = self.$el.find(self.options.dom.tabs);
		self.$slider = self.$el.find(self.options.dom.slider);
		self.$control = self.$el.find(self.options.dom.control);
		// self.$links = self.$el.find(self.options.dom.links);
		self.$numbered = self.$el.find(self.options.dom.numbered);
		self.$button = self.$el.find(self.options.dom.button);
		self.$mask = self.$el.find(self.options.dom.mask);
		self.$fileds = self.$el.find(self.options.dom.fileds);
		self.$reset = self.$el.find(self.options.dom.reset);
		self.$captcha = self.$el.find(self.options.dom.captcha);
		self.$phone = self.$el.find(self.options.dom.phone);
		self.$callback = self.$el.find(self.options.dom.callback);
		return self;
	}

	onTabChange(init, event) {
		const self = this;
		const isinit = init || false;
		const active = self.$tabs.filter(':checked').data('js');
		self.$el.data('params', [active]);

		if (self.preventChange) {
			event.preventDefault();
		} else {
			$.each(self.options.classes.state.tabs, function (key, item) {
				self.$el.toggleClass(item, active == key);
			});
			if (!isinit) {
				// self.links.play('band', 'long');
				// self.preventChange = true;
			}
			self.$window.trigger('yota.router.check');
		}

		return self;
	}

	onTabChangeEnd() {
		this.preventChange = false;
	}

	onControl(event) {
		const self = this;
		const active = self.$tabs.filter(':checked').data('js');
		const $control = $(event.currentTarget);

		self.slider[active][$control.data('js')]();

		return self;
	}

	validate() {
		const self = this;
		const valid = self.numbered.validate();
		if (valid > 0) {
			self.$phone.val(self.$numbered.val());
			self.$numbered.val(self.$numbered.val().replace(/[^\d]/gi, ''));
		}
		return valid;
	}

	onChange() {
		const self = this;
		self.$numbered.removeClass(self.options.classes.state.input.error);
		self.$captcha.removeClass(self.options.classes.state.input.error);
		if (self.$el.hasClass(self.options.classes.state.form.send)) {
			self.reset();
		}
		if (self.$numbered.val() === self.defNumberedValue) {
			self.$mask.removeClass(self.options.classes.state.mask.hidden);
		} else {
			self.$mask.addClass(self.options.classes.state.mask.hidden);
		}
	}

	reset() {
		const self = this;
		self.$numbered.val(self.defNumberedValue);
		self.$captcha.val('');
		self.$phone.val('');
		self.$callback.attr('data-phone', '+7 (xxx) xxx - xx - xx');
		self.$mask.removeClass(self.options.classes.state.mask.hidden);
		self.$el.removeClass(self.options.classes.state.form.captcha);
		self.$el.removeClass(self.options.classes.state.form.send);
		self.$numbered.removeClass(self.options.classes.state.input.error);
		self.$captcha.removeClass(self.options.classes.state.input.error);
	}

	onSubmit(e) {
		const self = this;
		e.preventDefault();
		if (self.$el.hasClass(self.options.classes.state.form.send)) {
			self.$numbered.focus();
			return;
		}

		if (!self.$el.hasClass(self.options.classes.state.form.captcha)) {
			if (self.validate() > 0) {
				self.$el.addClass(self.options.classes.state.form.captcha);
			} else {
				self.fileds.play('shake');
				self.$numbered.addClass(self.options.classes.state.input.error);
			}
		} else {
			const validCaptcha = self.$captcha.val().trim().length;
			$.ajax({
				url: self.$form.attr('action'),
				type: self.$form.attr('method'),
				data: self.$form.serialize(),
				dataType: 'json',
				success: function (json) {
					if (json && json.success && validCaptcha > 0) {
						self.$el.removeClass(self.options.classes.state.form.captcha);
						self.$callback.attr('data-phone', self.$phone.val());
						self.$el.addClass(self.options.classes.state.form.send);
						self.$numbered.val('');
					} else {
						self.fileds.play('shake');
						self.$captcha.addClass(self.options.classes.state.input.error);
					}
				}
			});
		}
	}

	update() {
		const params = this.$el.data('params') || [];
		if (params.length) {
			const $tab = this.$tabs.filter('[data-js="' + params[0] + '"]');
			if ($tab.length) {
				this.$tabs.not($tab).prop('checked', false);
				$tab.prop('checked', true);
				this.onTabChange(true);
			}
		}
	}

	activate() {
		if (!this.activated && this.$el.data('activated') === true) {
			this.activated = true;
			this.$el.addClass(this.options.classes.state.active);
		}
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();

			self.slider = {};
			self.$slider.each(function () {
				const $slider = $(this);
				self.slider[$slider.data('js')] = new Slider({
					el: $slider[0]
				}).render();
			});
			self.$control.on('click', self.onControl.bind(this));


			self.numbered = new Numbered(self.$numbered, {placeholder: true});
			self.fileds = new Animation({el: self.$fileds});
			self.$tabs.on('change click', self.onTabChange.bind(this, false));


			self.defNumberedValue = self.$numbered.val();
			self.$numbered.on('keyup focus', self.onChange.bind(this));
			self.$captcha.on('keyup focus', self.onChange.bind(this));
			self.$button.on('click', self.onSubmit.bind(this));
			self.$reset.on('click', self.reset.bind(this));

			self.$el
				.on('yota.router.update', self.update.bind(this))
				.on('yota.router.activate', this.activate.bind(this))
				.trigger('yota.router.update')
				.trigger('yota.router.activate');

			self.onTabChange(true);
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/application/application.js